import React from 'react'

import Modal from 'components/Modal'

import { aleloPodGroups, groups } from 'constants/pod-groups'

import { PodAliRef } from 'assets/img/card-icons'

import { Container, Title, Desc, Icon, Button } from './style'

const ProductAliRefModal = ({ onClose = () => {} }) => {
    const group = aleloPodGroups.find(
        (g) => g.type === groups.ALIMENTACAO_REFEICAO
    )

    return (
        <Modal open={true} onClick={onClose} closeBtn={true}>
            <Container data-testid={`${group.desc}Modal`}>
                <Icon
                    src={PodAliRef}
                    alt="Icone Alelo Pod Alimentação Refeição"
                />
                <Title>{group.desc}</Title>
                <Desc>
                    <b>Alimentação: </b>
                    Benefício utilizado para a compra de alimentos em ampla rede
                    credenciada de supermercados, açougues, quitandas e
                    similares.
                </Desc>
                <Desc>
                    <b>Refeição: </b>
                    Benefício voltado ao pagamento das refeições em ampla rede
                    credenciada, que inclui restaurantes, lanchonetes e
                    similares.
                </Desc>
                <Button type="button" onClick={onClose}>
                    Entendi
                </Button>
            </Container>
        </Modal>
    )
}

export default ProductAliRefModal
